/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ status: NonNullable<unknown> }} License_StatusInputs */



/**
* | output |
* | --- |
* | "License status: {status}" |
*
* @param {License_StatusInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const license_status = /** @type {((inputs: License_StatusInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<License_StatusInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Statut de la licence : ${i?.status}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Lizenzstatus: ${i?.status}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Stato della licenza: ${i?.status}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Статус лицензии: ${i?.status}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Estado de la licencia: ${i?.status}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`许可证状态：${i?.status}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`ライセンスステータス: ${i?.status}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`लाइसेंस स्थिति: ${i?.status}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Status da licença: ${i?.status}`)
	return /** @type {LocalizedString} */ (`License status: ${i?.status}`)
});